import { Button } from "@/components/buttons/Button";
import { nFormatter } from "@/common/utils/parseNumber";
import UsersIcon from "@/common/images/icons/users-filled.svg?react";
import CopyIcon from "@/common/images/icons/copy-filled.svg?react";
import galleryIcon from "@/common/images/icons/image_icon.svg";
import { useNavigate } from "react-router-dom";
import "./NicheCard.scss";
import { routes } from "@/common/utils/routes";

interface INicheCardProps {
  image: string | null;
  name: string;
  members: number;
  posts: number;
  nicheId: string;
}

export const NicheCard = ({
  image,
  name,
  members,
  posts,
  nicheId
}: INicheCardProps) => {
  const navigate = useNavigate();

  return (
    <div className="nicheCardItem">
      <div className="nicheCardImageWrap">
        <img src={image || galleryIcon} alt={name} className="nicheCardImage" />
      </div>
      <div className="nicheCardInfo">
        <h3 className="nicheName">{name}</h3>
        <div className="nicheStats">
          <div className="nicheStat">
            <UsersIcon />
            <b>{nFormatter(members)}</b>
            <span>members</span>
          </div>
          <div className="nicheStat">
            <CopyIcon />
            <b>{nFormatter(posts)}</b>
            <span>posts</span>
          </div>
        </div>
        <Button variant="secondary" size="s" onClick={() => navigate(routes.niche(nicheId))}>Visit Niche</Button>
      </div>
    </div>
  );
};
